<template>
  <div>
    <div>
      <div class="indexbf-top indexbefore-bg">
        <img
          src="../../assets/robot/bg.jpeg"
          alt=""
          class="indexbefore-bg-img"
        />
      </div>
      <div>
        <div class="shangxian" v-if="shangxian">产品即将上线,敬请期待!</div>
        <!-- 产品二维码 -->
        <div class="loginbox3" v-if="showQR">
          <h2 class="tishi">温馨提示</h2>
          <div class="daoqi">你的产品使用已到期，请重新购买</div>
          <div class="formContent">
            <div>
              亲爱的用户你好，你的发票风险报告服务已到期，无法使用本产品，如有需要请使用微信扫面下方二维码购买产品。购买产品前请详细阅读购买及使用说明，防止对你造成不便，谢谢！
            </div>
            <div class="lxieyi" @click="goSeeXieyi" v-if="moneyStatus == 1">
              《一键申报服务协议》
            </div>
            <div class="lxieyi" @click="goSeeXieyi" v-if="moneyStatus == 3">
              《发票风险报告服务协议》
            </div>

            <div class="product">产品名称：风险评估</div>
            <!-- <div class="product">产品范围：核定征收</div> -->
            <div class="qrclass"><div id="qrcode"></div></div>
            <div class="center"></div>
          </div>

          <div class="hdsy">
            <el-button type="primary" @click="goHome">回到首页</el-button>
          </div>
        </div>
        <!-- 账号密码登录 -->
        <div class="loginbox" v-if="loginstatus == 1">
          <div class="loginTipFont">密码登录</div>
          <div class="qyyw">企业业务</div>
          <div class="formContent">
            <div>
              <div class="card">
                <div class="selected">快捷登录</div>
              </div>
              <div class="inputbox">
                <el-form
                  label-width="0px"
                  :model="shform"
                  :rules="rules"
                  ref="ruleForm"
                >
                  <el-form-item prop="sh">
                    <el-input
                      v-model="shform.sh"
                      placeholder="请输入统一社会信用代码/纳税人识别号"
                    >
                      <div slot="prefix" class="el-input__icon creditCode"></div
                    ></el-input>
                  </el-form-item>

                  <el-form-item prop="sj">
                    <el-input
                      v-model="shform.sj"
                      placeholder="请输入手机号码/居民身份证号码/用户名"
                    >
                      <div
                        slot="prefix"
                        class="el-input__icon creditCode1"
                      ></div
                    ></el-input>
                  </el-form-item>

                  <el-form-item prop="password">
                    <el-input
                      v-model="shform.password"
                      placeholder="请输入电子税务局密码"
                      show-password
                    >
                      <div
                        slot="prefix"
                        class="el-input__icon creditCode2"
                      ></div>
                    </el-input>
                  </el-form-item>

                  <div class="zdkq" v-if="op != 'fxpg'">
                    <div>自动扣款</div>
                    <el-radio-group
                      v-model="shform.autoPay"
                      :disabled="moneyStatus == 2"
                      style="margin-left: 10px"
                    >
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </div>

                  <el-button
                    style="width: 100%; background: #168de9; color: white"
                    @click="loginCheck"
                    :loading="loginloading"
                    >登录</el-button
                  >

                  <div class="agree">
                    <el-checkbox v-model="agree">我已经阅读并同意</el-checkbox>
                    <div
                      class="xieyi"
                      @click="goSeeXieyi"
                      v-if="moneyStatus == 1"
                    >
                      《一键申报服务协议》
                    </div>

                    <div
                      class="xieyi"
                      @click="goSeeXieyi"
                      v-if="moneyStatus == 3"
                    >
                      《发票风险报告服务协议》
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>

        <!-- 填写验证码 -->
        <div class="loginbox1" v-if="loginstatus == 2">
          <div class="tabsCls">
            <div class="qydl">
              <div class="justifyCenterEnd" style="height: 100%">企业登录</div>
            </div>
            <div class="llk">
              <div class="tabSelect"></div>
            </div>
          </div>

          <div class="formContent">
            <div>
              <div class="inputbox">
                <el-form
                  label-width="0px"
                  :model="shform"
                  :rules="coderules"
                  ref="ruleForm1"
                >
                  <el-form-item prop="sj">
                    <el-input v-model="shform.sj" disabled>
                      <div
                        slot="prefix"
                        class="el-input__icon creditCode1"
                      ></div
                    ></el-input>
                  </el-form-item>

                  <el-form-item prop="messageCode">
                    <div class="messageCode">
                      <div class="duanxin">
                        <el-input
                          v-model="shform.messageCode"
                          placeholder="请输入短信验证码"
                        >
                          <div
                            slot="prefix"
                            class="el-input__icon creditCode4"
                          ></div
                        ></el-input>
                      </div>
                      <el-button
                        class="codeBtn"
                        style="width: 120px; background: #168de9; color: white"
                        :disabled="timer != null"
                        >{{ codeInfo }}</el-button
                      >
                    </div>
                  </el-form-item>

                  <el-button
                    style="width: 100%; background: #168de9; color: white"
                    @click="toShenbao"
                    :loading="loginloading"
                    v-if="moneyStatus == 1"
                    >一键申报</el-button
                  >

                  <el-button
                    style="width: 100%; background: #168de9; color: white"
                    @click="toqqfxpg"
                    :loading="loginloading"
                    v-if="moneyStatus == 3"
                    >风险评估</el-button
                  >
                  <el-button
                    style="width: 100%; background: #168de9; color: white"
                    @click="toShenbao"
                    :loading="loginloading"
                    v-if="moneyStatus == 2"
                    >扣款</el-button
                  >
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 操作选择 -->
      <div class="cx" v-if="showBtn">
        <el-card shadow="hover" class="cx_card" @click.native="toFx">
          风险评估查询
        </el-card>
        <el-card
          shadow="hover"
          class="cx_card"
          @click.native="toSb"
          style="margin-left: 20px"
        >
          申报结果查询
        </el-card>
      </div>

      <!-- 是否再次提示弹窗 -->
      <el-dialog
        :visible.sync="showMess"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        custom-class="nonheader"
        title="温馨提示"
      >
        <div>
          <h2 class="wenxin">温馨提示</h2>
          <div class="xieyiinfo" v-if="moneyStatus == 3">
            <p>
              为确保甲方快速、正确和安全使用发票风险报告服务（以下简称“服务”），根据《中华人民共和国民法典》、甲、乙双方经过平等协商，就乙方向甲方提供服务等事宜签订本协议：
            </p>
            <p>第一条：签约主体</p>
            <p>
              1.1本协议由申请开通服务的用户（简称“甲方”、“用户”或“您”）与成都千街万巷商务服务有限公司（简称“乙方”）签署。
            </p>
            <p>第二条：协议生效</p>
            <p>
              2.1
              您通过网络页面点击确认或以其他方式选择接受本协议，即表示您与乙方已达成协议并同意接受本协议的全部约定内容。本协议自您通过网络页面点击确认或以其他方式选择接受本协议之时起生效。
            </p>
            <p>第三条：服务内容</p>
            <p>3.1 乙方向甲方提供发票风险报告服务。</p>
            <p>第四条：甲方的权利义务</p>
            <p>4.1 甲方需向乙方提供真实发票数据。。</p>
            <p>4.2 甲方需自行准备符使用条件的硬件、软件及网络环境。</p>
            <p>第五条：乙方权利义务</p>
            <p>5.1 乙方负责指导甲方正确使用本次服务。</p>
            <p>5.2 乙方开通技术服务热线负责甲方的咨询工作。</p>
            <p>第六条：用户使用须知</p>
            <p>
              6.1
              用户同意并不可撤销地授权乙方通过相关技术手段进行以下操作：读取税控设备信息；登录电子税务局；记录和使用用户与本次服务相关的发票数据；修改、替换和升级软件等其他相关操作。
            </p>
            <p>
              6.2 发票数据抽取和备份服务
              （1）用户同意并不可撤销地授权乙方对用户的发票数据进行必要的采集、加工、存储、上传、下载、分析以提供优质高效的发票服务。乙方理解并认可用户的发票数据为用户自身的业务数据，用户对该数据拥有完全的所有权。
              （2）在用户具有特定需求并对乙方明确授权后，乙方有权将发票数据及其分析结果提供给用户指定的第三方服务商以满足用户的特定需求。
              （3）除本条第（2）款情形外，未经用户明确授权或同意，乙方不会将用户的发票数据披露给其他第三方，或者用于其他目的，但以下两种情形除外：
              第一、在国家有关机关依法查询或调阅用户业务数据时，按照相关法律法规或政策文件要求，乙方有义务配合并向行政、司法或其他第三方披露；
              第二、用户和乙方另行协商一致的。
            </p>
            <p>第七条：不可抗力</p>
            <p>
              7.1
              由于发生不能预见、不能避免并不能克服的不可抗力（是指地震、战争、罢工、台风、水灾、火灾、政府干预、封锁等不可预测、不可控制、不可避免的事故，包括网络服务特性而特有的事故，例如基础电信运营商故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素）情形，致使直接影响本协议的履行或不能按照本协议项下之约定履行时，遇有不可抗力的一方应当立即通知对方，并在发生不可抗力之日起30天内，提供不可抗力详情及协议不能履行或部分不能履行，或需要延期履行理由的有效书面证明。
            </p>
            <p>
              7.2、根据不可抗力对本协议的影响程度，各方应当协商是否解除本协议或部分、全部免除履行本协议的责任，或延期履行本协议。因不可抗力发生是损失，各方均不承担违约责任。
            </p>
            <p>第八条：其他约定</p>
            <p>
              8.1
              本协议在履行过程中如有争议，双方应协商解决，协商不成，可提交乙方所在地有管辖权的法院进行诉讼。
            </p>
            <p>
              8.2
              如您需要纸质服务协议，请销售人员预留通讯地址后，我公司将通过顺丰快递（到付）送达。
            </p>
          </div>
        </div>
        <div class="nexttshi">
          <el-checkbox size="medium" border v-model="nextAlert"
            >我知道了，以后不再提示</el-checkbox
          >
        </div>
        <div class="dialog-footer">
          <el-button
            style="background: #53acf3; color: white"
            @click="sureAlert"
            >继续</el-button
          >
        </div>
      </el-dialog>

      <!-- 协议 -->
      <el-dialog title="服务协议" :visible.sync="showXieyi">
        <div class="xieyiinfo" v-if="moneyStatus == 1">
          <p class="shuoming">
            1.使用说明也是大使用说明也是大v复活节萨芬使用说明也是大v复活节萨芬使用说明也是大v复活节萨芬使用说明也是大v复活节萨芬使用说明也是大v复活节萨芬使用说明也是大v复活节萨芬v复活节萨芬
          </p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
          <p class="shuoming">1.使用说明也是大v复活节萨芬</p>
        </div>

        <div class="xieyiinfo" v-if="moneyStatus == 3">
          <p>
            为确保甲方快速、正确和安全使用发票风险报告服务（以下简称“服务”），根据《中华人民共和国民法典》、甲、乙双方经过平等协商，就乙方向甲方提供服务等事宜签订本协议：
          </p>
          <p>第一条：签约主体</p>
          <p>
            1.1本协议由申请开通服务的用户（简称“甲方”、“用户”或“您”）与成都千街万巷商务服务有限公司（简称“乙方”）签署。
          </p>
          <p>第二条：协议生效</p>
          <p>
            2.1
            您通过网络页面点击确认或以其他方式选择接受本协议，即表示您与乙方已达成协议并同意接受本协议的全部约定内容。本协议自您通过网络页面点击确认或以其他方式选择接受本协议之时起生效。
          </p>
          <p>第三条：服务内容</p>
          <p>3.1 乙方向甲方提供发票风险报告服务。</p>
          <p>第四条：甲方的权利义务</p>
          <p>4.1 甲方需向乙方提供真实发票数据。。</p>
          <p>4.2 甲方需自行准备符使用条件的硬件、软件及网络环境。</p>
          <p>第五条：乙方权利义务</p>
          <p>5.1 乙方负责指导甲方正确使用本次服务。</p>
          <p>5.2 乙方开通技术服务热线负责甲方的咨询工作。</p>
          <p>第六条：用户使用须知</p>
          <p>
            6.1
            用户同意并不可撤销地授权乙方通过相关技术手段进行以下操作：读取税控设备信息；登录电子税务局；记录和使用用户与本次服务相关的发票数据；修改、替换和升级软件等其他相关操作。
          </p>
          <p>
            6.2 发票数据抽取和备份服务
            （1）用户同意并不可撤销地授权乙方对用户的发票数据进行必要的采集、加工、存储、上传、下载、分析以提供优质高效的发票服务。乙方理解并认可用户的发票数据为用户自身的业务数据，用户对该数据拥有完全的所有权。
            （2）在用户具有特定需求并对乙方明确授权后，乙方有权将发票数据及其分析结果提供给用户指定的第三方服务商以满足用户的特定需求。
            （3）除本条第（2）款情形外，未经用户明确授权或同意，乙方不会将用户的发票数据披露给其他第三方，或者用于其他目的，但以下两种情形除外：
            第一、在国家有关机关依法查询或调阅用户业务数据时，按照相关法律法规或政策文件要求，乙方有义务配合并向行政、司法或其他第三方披露；
            第二、用户和乙方另行协商一致的。
          </p>
          <p>第七条：不可抗力</p>
          <p>
            7.1
            由于发生不能预见、不能避免并不能克服的不可抗力（是指地震、战争、罢工、台风、水灾、火灾、政府干预、封锁等不可预测、不可控制、不可避免的事故，包括网络服务特性而特有的事故，例如基础电信运营商故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素）情形，致使直接影响本协议的履行或不能按照本协议项下之约定履行时，遇有不可抗力的一方应当立即通知对方，并在发生不可抗力之日起30天内，提供不可抗力详情及协议不能履行或部分不能履行，或需要延期履行理由的有效书面证明。
          </p>
          <p>
            7.2、根据不可抗力对本协议的影响程度，各方应当协商是否解除本协议或部分、全部免除履行本协议的责任，或延期履行本协议。因不可抗力发生是损失，各方均不承担违约责任。
          </p>
          <p>第八条：其他约定</p>
          <p>
            8.1
            本协议在履行过程中如有争议，双方应协商解决，协商不成，可提交乙方所在地有管辖权的法院进行诉讼。
          </p>
          <p>
            8.2
            如您需要纸质服务协议，请销售人员预留通讯地址后，我公司将通过顺丰快递（到付）送达。
          </p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import API from '@/api/api'
import store from 'store'
import { USR_TOKEN } from '@/util/const'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      shangxian: false,
      paysuccess: null,
      loginsuccess: null,
      loginstatus: 3, //1输入账号  2输入验证码
      showXieyi: false, //协议展示
      showMess: false,
      nextAlert: false, //不再提示弹框
      showBtn: false,
      ph: '',
      op: '', //fxpg
      moneyStatus: 0, //2扣款 1申报  3是评估
      loginloading: false,
      agree: false,
      activeIndex: '1',
      shdl: false, //是否展示登录框
      showQR: false,
      codeInfo: '获取验证码',
      // shform: {
      //   sh: '',
      //   password: 'cdjs123456',
      //   sj: '17313103551',
      //   autoPay: 0,
      // },
      shform: {
        sh: '',
        password: '',
        sj: '',
        autoPay: 0,
      },
      payInfo: '',
      personlist: [1, 2, 3],
      SSO_LOGIN_TGC: '', //cookie
      bsrType: '',
      yzfs: '',
      timer: null, //计时器
      ltimer: null, //跳转倒计时延迟
      countdown: 300, //短信倒计时
      djs: 10,
      rules: {
        sh: [
          {
            required: true,
            message: '请输入统一社会信用代码/纳税人识别号',
            trigger: 'blur',
          },
        ],
        sj: [
          {
            required: true,
            message: '请输入手机号码/居民身份证号码/用户名',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入电子税务局密码', trigger: 'blur' },
        ],
      },
      coderules: {
        messageCode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    // this.op='fxpg'
    // this.loginstatus = 2
    // this.shdl = true
    // this.moneyStatus = 3
    // this.setTime()
    // return

    if (this.$route.query.nsrsbh) {
      this.shform.sh = this.$route.query.nsrsbh
    }
    //直接扣款
    if (this.$route.query.type && this.$route.query.type == 1) {
      this.shdl = true
      this.moneyStatus = 2
      this.shform.autoPay = 1
      return
    } else if (this.$route.query.type && this.$route.query.type == 2) {
      this.shdl = true
      this.moneyStatus = 3
    }
    if (this.$route.query.skph) {
      this.ph = this.$route.query.skph
    }
    if (this.$route.query.op) {
      this.op = this.$route.query.op
    }
    if (this.op == 'cxbg') {
      this.showBtn = true
      return
    }
    if (this.op == 'fxpg') {
      this.getFxpgPay()
    }
    if (this.op == 'yjsb') {
      this.getShenPay()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.ltimer)
    clearInterval(this.paysuccess)
    this.timer = null
    this.ltimer = null
    this.paysuccess = null
  },
  mounted() {},
  methods: {
    //回到首页
    goHome() {
      this.$router.push({
        name: 'index', //index
      })
    },
    //轮询获取登录验证码状态
    morehqdlyzmzt() {
      let _this = this
      this.loginsuccess = setInterval(() => {
        _this.hqdlyzmzt()
      }, 5000)
    },
    //获取登录验证码状态
    hqdlyzmzt() {
      let request = {
        shxydm: this.shform.sh,
        isJson: true,
      }
      API.hqdlyzmzt(request)
        .then(res => {
          if (res.data.statusCode != 200) {
            if (this.loginsuccess == null) {
              this.morehqdlyzmzt()
            }
          } else {
            if (res.data.result.ztcode == 1) {
              if (this.loginsuccess == null) {
                this.morehqdlyzmzt()
              }
            } else if (res.data.result.ztcode == 2) {
              clearInterval(this.loginsuccess)
              this.loginloading = false
              this.loginsuccess = null
              this.$alert(res.data.result.msg, '提示', {
                confirmButtonText: '确定',
                type: 'warning',
              })
              //重新登录
            } else {
              clearInterval(this.loginsuccess)
              this.setTime()
              this.loginstatus = 2
              this.loginloading = false
              this.loginsuccess = null
              //发起申报或者风险操作
            }
          }
        })
        .catch(err => {
          if (this.loginsuccess == null) {
            this.moreSure()
          }
        })
    },
    //轮询请求支付结果
    moreSure() {
      let _this = this
      this.paysuccess = setInterval(() => {
        if (_this.op == 'fxpg') {
          _this.getFxpgPay()
        }
        if (_this.op == 'yjsb') {
          _this.getShenPay()
        }
      }, 5000)
    },
    //获取申报支付状态
    async getShenPay() {
      let request = {
        shxydm: this.shform.sh,
        //shxydm:'92510104MA6CNKUP4D',
        isJson: true,
      }
      const res = await API.getShenbaoPay(request)

      if (res.data.statusCode != 200) {
        if (res.data.message == '产品即将上线,敬请期待!') {
          this.shangxian = true
        }
        this.$alert(res.data.message, '提示', {
          type: 'warning',
        })
        return
      }
      //zt 为0无支付记录  1有支付记录没申报记录    2当前有正在申报的记录
      this.payInfo = res.data.result
      if (this.payInfo.zt == 0) {
        if (this.showQR == true) return
        this.shdl = false
        this.showQR = true
        this.$nextTick(() => {
          this.qrcode()
          if (this.paysuccess == null) {
            this.moreSure()
          }
        })
      } else if (this.payInfo.zt == 1) {
        if (this.paysuccess != null) {
          clearInterval(this.paysuccess)
        }
        this.paysuccess = null
        this.loginstatus = 1
        this.showQR = false
        this.shdl = true
        this.moneyStatus = 1
      } else {
        if (this.paysuccess != null) {
          clearInterval(this.paysuccess)
        }
        //这里记得删除
        this.paysuccess = null
        this.loginstatus = 1
        this.showQR = false
        this.shdl = true
        this.moneyStatus = 1

        return
        this.paysuccess = null
        this.$router.replace({
          name: 'declare',
        })
        //跳转到申报信息页面
      }
    },
    //获取风险评估支付状态
    async getFxpgPay() {
      let request = {
        shxydm: this.shform.sh,
        //shxydm: '92510104MA6CNKUP4D',
        isJson: true,
      }
      const res = await API.cxfxpgzfjl(request)
      console.log(res)

      if (res.data.statusCode != 200) {
        if (res.data.message == '产品即将上线,敬请期待!') {
          this.shangxian = true
        }
        this.$alert(res.data.message, '提示', {
          type: 'warning',
        })
        // if (this.paysuccess == null) {
        //   this.moreSure()
        // }
        return
      }
      //zt 为0无支付记录  1有支付记录没申报记录    2当前有正在申报的记录
      this.payInfo = res.data.result
      if (this.payInfo.zt == 0) {
        if (this.showQR == true) return
        this.shdl = false
        this.showQR = true
        this.$nextTick(() => {
          this.qrcode()
          if (this.paysuccess == null) {
            this.moreSure()
          }
        })
      } else if (this.payInfo.zt == 1) {
        if (this.paysuccess != null) {
          clearInterval(this.paysuccess)
        }
        this.paysuccess = null
        this.loginstatus = 1
        this.showQR = false
        this.shdl = true
        this.moneyStatus = 3
      } else {
        if (this.paysuccess != null) {
          clearInterval(this.paysuccess)
        }
        this.paysuccess = null
        this.$router.replace({
          name: 'declare',
        })
        //跳转到申报信息页面
      }
    },
    //短信倒计时
    setTime() {
      let _this = this
      this.timer = setInterval(() => {
        if (_this.countdown > 0 && _this.countdown <= 300) {
          _this.countdown--
          if (_this.countdown !== 0) {
            _this.codeInfo = '重新发送(' + _this.countdown + ')'
          } else {
            clearInterval(_this.timer)
            _this.loginstatus = 1
            _this.codeInfo = '获取验证码'
            _this.countdown = 300
            _this.timer = null
          }
        }
      }, 1000)
    },
    //登录校验
    loginCheck() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (!this.agree) {
            this.$alert('您还未同意使用协议', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
            })
            return
          }

          let isalert = localStorage.getItem('isalert')
          if (isalert == 'false' || isalert == null) {
            this.showMess = true
            return
          }
          this.hqdlyzm()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //登录
    hqdlyzm() {
      this.loginloading = true
      let request = {
        shxydm: this.shform.sh,
        password: this.shform.password,
        telNo: this.shform.sj,
        isJson: true,
      }
      API.hqdlyzm(request)
        .then(res => {
          // this.setTime()

          if (res.data.statusCode == 200) {
            this.hqdlyzmzt()
          } else {
            this.loginloading = false
          }
          // this.loginstatus = 2
          // this.loginloading = false
        })
        .catch(err => {
          //this.setTime()
          // this.loginstatus = 2
          // this.loginloading = false
        })
    },
    //进行一键申报
    async toShenbao() {
      this.loginloading = true
      let request = {
        shxydm: this.shform.sh,
        password: this.shform.password,
        telNo: this.shform.sj,
        yzm: this.shform.messageCode,
        kkFlag: this.shform.autoPay,
        isJson: true,
      }
      API.qqsbkk(request)
        .then(res => {
          this.loginloading = false
          console.log(res)
          if (res.data.statusCode == 200) {
            this.$router.replace({
              name: 'declare',
            })
          }
        })
        .catch(err => {
          this.loginloading = false
        })
    },
    //进行风险评估
    async toqqfxpg() {
      this.loginloading = true
      let request = {
        shxydm: this.shform.sh,
        password: this.shform.password,
        yzm: this.shform.messageCode,
        telNo: this.shform.sj,
        isJson: true,
      }
      API.qqfxpg(request)
        .then(res => {
          this.loginloading = false
          if (res.data.statusCode == 200) {
            this.toTime()
            this.$alert('风险评估操作成功,稍后自动跳转到结果页面', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              callback: () => {
                this.toFx()
              },
            })
          }
        })
        .catch(err => {
          this.loginloading = false
        })
    },
    //跳转倒计时
    toTime() {
      let _this = this
      this.ltimer = setInterval(() => {
        if (_this.djs > 0 && _this.djs <= 10) {
          _this.djs--
          if (_this.djs !== 0) {
          } else {
            clearInterval(_this.ltimer)
            _this.countdown = 10
            _this.ltimer = null
            _this.$msgbox.close()
            _this.toFx()
          }
        }
      }, 1000)
      // this.ltimer = setTimeout(() => {
      //   this.$msgbox.close()
      //   that.toFx()
      // }, 10000)
    },
    //创建二维码
    qrcode() {
      let token = store.get(USR_TOKEN)
      let nsrsbh = this.shform.sh //92510104MA6CNKUP4D
      //let nsrsbh = '92510104MA6CNKUP4D' //92510104MA6CNKUP4D
      let skph = this.ph
      //let skph = '929908899119'
      let id = this.userInfo.id
      //http://192.168.3.19:8080
      //https://www.chinaqjwx.cn/qf_moblie/#/ckzs
      let op = this.op
      //let text = 'https://www.chinaqjwx.cn/qf_moblie/#/ckzs?op='
      let text =
        'https://www.chinaqjwx.cn/qf_moblie/#/ckzs?op=' +
        op +
        '&nsrsbh=' +
        nsrsbh +
        '&skph=' +
        skph +
        '&id=' +
        id +
        '&token=' +
        token
      let qrcode = new QRCode('qrcode', {
        width: 300, // 设置宽度，单位像素
        height: 300, // 设置高度，单位像素
        text: text, // 设置二维码内容或跳转地址
      })
      console.log(text)
    },
    //跳转到风险评估
    toFx() {
      this.$router.replace({
        name: 'risk',
      })
    },
    //跳转到申报
    toSb() {
      this.$router.replace({
        name: 'declare',
      })
    },
    //温馨提示弹窗确定
    sureAlert() {
      localStorage.setItem('isalert', this.nextAlert)
      this.showMess = false
      this.hqdlyzm()
    },
    //查看协议
    goSeeXieyi() {
      this.showXieyi = true
    },
  },
}
</script>
<style>
.robot .selected {
  color: #409eff;
  font-weight: 700;
}
</style>

<style lang="stylus" scoped>
.loginbox {
  width: 458px;
  height: 500px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0 0 0 0.45);
  position: absolute;
  top: 86px;
  left: 50%;
  transform: translateX(-50%);
}

.loginbox1 {
  width: 458px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0 0 0 0.45);
  position: absolute;
  top: 86px;
  left: 50%;
  transform: translateX(-50%);
}

.loginbox3 {
  width: 800px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0 0 0 0.45);
  position: absolute;
  top: 86px;
  left: 50%;
  transform: translateX(-50%);
}

.loginTipFont {
  font-size: 20px;
  color: #686868;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-top: 20px;
  margin-left: 33px;
}

.qyyw {
  width: 100%;
  text-align: center;
  heigit: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #505050;
  font-weight: 700;
  border-bottom: 2px solid #0066d1;
}

.formContent {
  padding: 10px 20px 20px;
}

.card {
  width: 100%;
  font-size: 14px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.selected {
  width: 136px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 2px;
  background-color: #168de9;
  color: #e5eefa;
}

.inputbox {
  margin-top: 14px;
}

.creditCode {
  background: url('../../assets/robot/a.png') no-repeat 1px 9px !important;
}

.creditCode1 {
  background: url('../../assets/robot/b.png') no-repeat 1px 9px !important;
}

.creditCode2 {
  background: url('../../assets/robot/c.png') no-repeat 1px 9px !important;
}

.creditCode4 {
  background: url('../../assets/robot/d.png') no-repeat 1px 9px !important;
}

/deep/ .el-form-item {
  margin-bottom: 17px;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: white;
  cursor: text;
}

/deep/ .el-input.is-disabled .el-input__icon {
  cursor: text;
}

.zdkq {
  display: flex;
  align-items: center;
  margin-bottom: 17px;
}

.qydl {
  height: 100%;
  padding-bottom: 12px;
  box-sizing: border-box;
}

.tabsCls {
  width: 100%;
  height: 85px;
  border-bottom: 2px solid #bbb;
}

.llk {
  height: 4px;
  box-sizing: border-box;
}

.tabSelect {
  height: 2px;
  background: #0066d1;
}

.justifyCenterEnd {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  text-align: center;
}

.duanxin {
  width: calc(100% - 130px);
}

/deep/ .nonheader .el-dialog__header {
  display: none;
}

/deep/.el-checkbox.is-bordered.is-checked {
  border-color: #409EFF;
}

.cx_card {
  width: 200px;
  height: 100px;
  text-align: center;
  line-height: 50px;
  background-color: #ff7a00;
  color: white;
  cursor: pointer;
}

.cx {
  display: flex;
  justify-content: center;
  margin-top: -50px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #409eff;
  background: #409eff;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #409EFF;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #409EFF;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #409eff;
  background: #409eff;
}

.agree {
  margin-left: 50px;
  margin-top: 20px;
  display: flex;
}

.xieyi {
  margin-left: 10px;
  color: #409EFF;
  cursor: pointer;
}

.lxieyi {
  text-align: center;
  color: #409EFF;
  cursor: pointer;
  margin-top: 10px;
}

.login {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: black;
}

.tishi {
  text-align: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrclass {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.daoqi {
  text-align: center;
  color: red;
  font-size: 18px;
}

.product {
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #409EFF;
}

/deep/ .el-button--primary.is-plain {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff;
}

/deep/ .el-input__inner:focus {
  border-color: #d9d9d9;
}

/deep/ .el-menu--horizontal > .el-menu-item {
  height: 40px;
  line-height: 40px;
}

.shtitle {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  font: normal 14px / 20px arial, sans-serif;
}

.messageCode {
  display: flex;
  justify-content: space-between;
}

.indexbf-top {
  overflow: visible;
  width: 100%;
  height: 460px;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: relative;
}

.indexbefore-bg-img {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  vertical-align: middle;
}

.wenxin {
  text-align: center;
}

.shuoming {
  color: black;
  font-size: 16px;
}

.nexttshi {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.dialog-footer {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.xieyiinfo {
  height: 500px;
  overflow: auto;
}

.shangxian {
  text-align: center;
  font-size: 18px;
  font-weight: blod;
  margin-top: 20px;
}
.hdsy{
  margin-top:15px;
  margin-bottom:15px;
  display:flex;
  justify-content: center;
}
</style>
